import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';
import ReactJson from 'react-json-view'
import $ from "jquery";

const v = require('voca');
import { makeInput } from "common-import/custom";
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";

const propertyContractor = ["name", "type", "address", "city", "country", "district", "phone", "fax", "website", "email", "taxCode", "origination", "foundedYear", "description", "isHouseLinkMember", "isVerifiedLicense", "totalRanking", "typeOfCompany", "qualityManagement", "language", "numberOfExpProject", "numberOfEmployees", "numberOfBiddedProject", "numOfRating", "revenue", "unitRevenue", "price", "unitPrice", "prizes", "numberOfLikes", "houselinkRanking", "services"];
let initialState = {};
propertyContractor.forEach(val => initialState[val] = "");

@inject("contractorStore", "languageStore", "userStore") @observer
class ContractorProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contractor: initialState,
      current: initialState
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    const { contractorStore, match, languageStore } = this.props;
    this.setCurrentContractor();
    // languageStore.loadInitialData();
  }

  setCurrentContractor = () => {
    const { contractorStore, match } = this.props;
    let contractor = contractorStore.setCurrentContractor(match.params.id);
    let current = {};
    propertyContractor.forEach(val => current[val] = contractor[val]);
    this.setState({ contractor, current });
  }

  editProfile = async e => {
    e.preventDefault();
    const { contractorStore } = this.props;
    const { contractor, current } = this.state;
    let updateObject = VarHelper.filterEmptyObjProp(current);

    updateObject.numberOfExpProject = +updateObject.numberOfExpProject;
    updateObject.numberOfBiddedProject = +updateObject.numberOfBiddedProject;
    updateObject.numOfRating = +updateObject.numOfRating;
    updateObject.numberOfLikes = +updateObject.numberOfLikes;

    for(let key in updateObject) {
      if(updateObject[key] == contractor[key]) delete updateObject[key];
    }
    let updateResult = await contractorStore.update(updateObject);
    if (!!updateResult.error) window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(updateResult.error));
    else {
      window.toast.info("Đã cập nhật thành công");
      let fullNewObject = { ...contractorStore.currentContractor, ...updateObject };
      contractorStore.setProp("currentContractor", fullNewObject);
      this.setState({ contractor: fullNewObject});
    }

  }

  renderContractorForm = () => {
    const { languageStore } = this.props;
    return (
      <Form action="" method="post" onSubmit={e => e.preventDefault()}>
        {
          propertyContractor.map((property, index) => {
            if(property == "typeOfCompany") {
              return (
                <FormGroup key={"property" + index}>
                  <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                  <Input value={this.state.current.typeOfCompany} type="select" defaultValue=""
                    onChange={e => {
                      let { current } = this.state;
                      current.typeOfCompany = $(e.target).val();
                      this.setState({ current })
                    }}>
                    {languageStore.typeOfCompany.slice().map((item, i) => (
                      <option key={"option"+i} value={item.index}>{item.title}</option>
                    ))}
                  </Input>
                </FormGroup>
              )
            }
            return (
              <FormGroup key={"property" + index}>
                <Label htmlFor={"nf-" + property}>{v.capitalize(property)}:</Label>
                {/* {makeInput(this, property)(<Input type="text" id={"nf-" + property} name={"nf-" + property} />)} */}
                <Input 
                  type="text" 
                  id={"nf-" + property} 
                  name={"nf-" + property}
                  value={this.state.current[property]} 
                  onChange={e => this.setState({ 
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                 />
              </FormGroup>
            );
          })
        }

      </Form>
    )
  }

  changeLogo = async e => {
    const file = e.target.files[0];
    const { contractorStore } = this.props;
    let uploadedAvatarUrl = await Request.upload(file);
    contractorStore.setProp("currentContractor", {
      ...contractorStore.currentContractor,
      logo: uploadedAvatarUrl
    });
    let result = await contractorStore.update({ logo: uploadedAvatarUrl });
    if (!!result.error) window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
  }

  approveContractor = async e => {
    e.preventDefault();
    const { contractorStore, match } = this.props;
    let continueApprove = confirm("Bạn có chắc chắn muốn xác thực nhà thầu này?");
    if(continueApprove) {
      // alert("Chức năng xác thực đang hoàn thiện");
      let result = await contractorStore.approve({ id: match.params.id, approved: true });
      if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
      window.toast.info("Xác thực nhà thầu thành công");
      this.setState({ contractor: { ...this.state.contractor, approved: 1 } })
    }
  }

  renderApprove = () => {
    const { approved } = this.state.contractor;
    if (approved === undefined || approved === "" || approved === true || approved === 1) return null;
    return (
      <Row style={{ marginBottom: 30 }}>
        <Col xs="12" md="12" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <h3 style={{ marginRight: 10 }}>Nhà thầu này chưa được xác thực.</h3>
          <Button style={{ display: "inline-block" }} type="submit" size="sm" color="primary" onClick={this.approveContractor}><i className="fa fa-dot-circle-o"></i> Xác thực</Button>
        </Col>
      </Row>
    )
  }

  doVerify = async () => {
    const { contractorStore, match } = this.props;
    const { current } = this.state;
    const { isVerifiedFinances, isVerifiedLicense, isHouseLinkMember } = current;
    const result = await contractorStore.updateHouseLink({
      isVerifiedFinances: isVerifiedFinances == null ? 0 : isVerifiedFinances,
      isVerifiedLicense: isVerifiedLicense == null ? 0 : isVerifiedLicense,
      isHouseLinkMember: isHouseLinkMember == null ? false : isHouseLinkMember,
      id: match.params.id
    });
    if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
    window.toast.info("Verify nhà thầu thành công");
  }

  onChangeVerify = (e, property) => {
    const mapValue = {
      isHouseLinkMember: [true, false],
      isVerifiedLicense: [1, 0],
      isVerifiedFinances: [1, 0],
    };
    let { current } = this.state;
    current[property] = e.target.checked ? mapValue[property][0] : mapValue[property][1];
    this.setState({ current });
  }

  renderVerifyButtons = () => {
    const { current } = this.state;
    const { isVerifiedFinances, isVerifiedLicense, isHouseLinkMember } = current;
    return (
      <Card>
        <CardHeader>
          <i className="fa fa-envelope-open"></i> Thao tác Verify
        </CardHeader>
        <CardBody>
          <div>
            <p><label><input type="checkbox" checked={isVerifiedLicense == 1} onChange={e => this.onChangeVerify(e, 'isVerifiedLicense')} /> Xác thực License</label></p>
            <p><label><input type="checkbox" checked={isVerifiedFinances == 1} onChange={e => this.onChangeVerify(e, 'isVerifiedFinances')} /> Xác thực Finances</label></p>
            <p><label><input type="checkbox" checked={isHouseLinkMember} onChange={e => this.onChangeVerify(e, 'isHouseLinkMember')} /> Xác thực Houselink member</label></p>
          </div>
          <Button color="primary" onClick={this.doVerify}>Verify</Button>
        </CardBody>
      </Card>
    );
  }

  renderLogo = (logo) => (
    <Card>
      <CardHeader>
        <i className="fa fa-envelope-open"></i> Logo
              </CardHeader>
      <CardBody>
        <div style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          display: "flex"
        }}>
          <img src={VarHelper.img(logo) || "http://www.toyota-global.com/pages/contents/company/profile/images/company_profile_01.jpg"}
            style={{ width: 300, height: 300, borderRadius: "100%", marginBottom: 20 }} />
          <input type="file" id="upload-logo" name="upload-logo" style={{ display: "none" }} onChange={this.changeLogo} />
          <Button color="danger"><label htmlFor="upload-logo"><i className="fa fa-camera"></i> Upload new logo</label></Button>
        </div>

      </CardBody>
    </Card>
  )

  render() {
    const { contractorStore, match } = this.props;
    const { currentContractor } = contractorStore;
    return (
      <div className="animated fadeIn">
        {this.renderApprove()}
        <Row>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Id: <strong>{this.props.match.params.id}</strong>
              </CardHeader>
              <CardBody>
                {/* {MobXHelper.passDown("contractorStore")(this.renderContractorForm(currentContractor))} */}
                {this.renderContractorForm()}
              </CardBody>
              <CardFooter>
                <Button type="submit" size="sm" color="primary" onClick={this.editProfile}><i className="fa fa-dot-circle-o"></i> Save</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button>
              </CardFooter>
            </Card>
          </Col>
          <Col xs="12" md="6">
            {this.renderLogo(currentContractor.logo)}
            {this.renderVerifyButtons()}
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Documents Verify
              </CardHeader>
              <CardBody>
                {/* {this.state.verifyDocuments == null && <em>Chưa có documents verify</em>} */}
                <ReactJson 
                  src={currentContractor.verifyDocuments || { message: 'Chưa có' }}
                  name="verifyDocuments"
                  displayDataTypes={false}
                  theme={"ocean"}
                />
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Documents
              </CardHeader>
              <CardBody>
                <ReactJson 
                  src={currentContractor.documents || { message: 'Chưa có' }}
                  name="documents"
                  displayDataTypes={false}
                  theme={"ocean"}
                />
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Finances
              </CardHeader>
              <CardBody>
                <ReactJson 
                  src={currentContractor.finances || { message: 'Chưa có' }}
                  name="finances"
                  displayDataTypes={false}
                  theme={"ocean"}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="12" >
            {/* <div style={{overflowX:'auto'}}>
              <JSONViewer json={currentProject} />
            </div> */}
            <ReactJson 
              src={currentContractor}
              name={currentContractor.name}
              displayDataTypes={false}
              theme={"ocean"}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default ContractorProfile;


// WEBPACK FOOTER //
// ./src/views/Contractors/ContractorProfile.js